import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import {
  TramiteRol, RolTramiteDefaul
} from '@app/shared';

@Injectable()
export class ManagementGroupsProcessDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) {}

  /**
   * Consulta los roles(Grupos) de un tramite en especifico
   *
   * @param {number} idTramite
   * @returns {Observable<TramiteRol[]>}
   * @memberof ManagementGroupsProcessDataService
   */
  getRolesTramites(idTramite: number): Observable<TramiteRol[]> {
    return this.http.get<TramiteRol[]>(this.api.get('rolesTramite', [idTramite]));
  }

  /**
   * Agrega un rol(Grupo) a un tramite
   *
   * @param {RolTramiteDefaul} rolTramite
   * @returns {Promise<boolean>}
   * @memberof ManagementGroupsProcessDataService
   */
  addGroupTramite(rolTramite: RolTramiteDefaul): Promise<boolean> {
    return new Promise((resolve, reject) => {
      // tslint:disable-next-line:max-line-length
      this.http.skipErrorHandler().post<boolean>(this.api.get('rolesTramite'), rolTramite).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Grupo agregado correctamente al trámite');
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operación');
          }
          reject(err);
        }
      );
    });
  }

  /**
   * Elimina un rol(Grupo) a un tramite
   *
   * @param {number} idRolTramite
   * @returns {Promise<boolean>}
   * @memberof ManagementGroupsProcessDataService
   */
  deleteGroupTramite(idRolTramite: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      // tslint:disable-next-line:max-line-length
      this.http.skipErrorHandler().delete<boolean>(this.api.get('rolesTramite', [idRolTramite])).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Grupo eliminado correctamente al trámite');
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operación');
          }
          reject(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/groups-permissions/management-groups-process/shared/management-groups-process.data.service.ts